import React, { useMemo, useState } from 'react';

// A lightweight typeahead over games already on the site (reviewed or still on the to-do list).
// Picking a result just autofills the title/poster fields below it - nothing here is stored as a
// reference, so the fields stay freely editable afterwards.
function GameSearchPicker({ suggestions, onPick, placeholder = 'Suggest from an existing game...' }) {
  const [query, setQuery] = useState('');

  const matches = useMemo(() => {
    if (!query) return [];
    const q = query.toLowerCase();
    return suggestions.filter((g) => g.title.toLowerCase().includes(q)).slice(0, 8);
  }, [suggestions, query]);

  return (
    <div className="goty-picker">
      <input
        type="text"
        placeholder={placeholder}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      {query && (
        <ul className="goty-picker-results">
          {matches.map((g) => (
            <li key={`${g.source || 'games'}-${g.id}`}>
              <button type="button" onClick={() => { onPick(g); setQuery(''); }}>{g.title}</button>
            </li>
          ))}
          {matches.length === 0 && <li className="goty-picker-empty">No matches</li>}
        </ul>
      )}
    </div>
  );
}

export default GameSearchPicker;
